export const getStatusColor = (status) => {
  switch (status) {
    case 'Ready':
      return 'green';
    case 'Processing':
      return 'gold';
    case 'Pending':
      return 'blue';
    case 'Shipped':
      return 'blue';
    case 'Delivered':
      return 'green';
    default:
      return 'default';
  }
};

export const getCategoryColor = (category) => {
  switch (category) {
    case 'Hypertension':
      return 'blue';
    case 'Diabetes':
      return 'green';
    case 'Cholesterol':
      return 'orange';
    case 'Antibiotic':
      return 'red';
    case 'Antidepressant':
      return 'purple';
    default:
      return 'default';
  }
};
